/*
 * @flow
 */

import qs from 'querystring';
import { getCurrentScript } from '../util';
import type Orchestrator from '../orchestrator';
import type {
  UniverseEmbedWidget as EmbedWidget,
  WidgetInitState
} from '../widget';

export default function registerWidget(orc: Orchestrator) {
  const thisScript: ?HTMLElement = getCurrentScript();

  if (!thisScript) {
    return;
  }

  const widgetType: ?string = thisScript.getAttribute('data-widget-type');
  const widgetHeight: ?string = thisScript.getAttribute('data-widget-height');
  const targetType: ?string = thisScript.getAttribute('data-target-type');
  const targetId: ?string = thisScript.getAttribute('data-target-id');
  const filtersEnabled: ?boolean = thisScript.getAttribute('data-filter') == 'true';
  // Set by a host that already pings this listing (fan's EDP), so the widget's
  // ping doesn't overwrite its 'edp' area with 'widget'.
  const skipPresence: boolean = thisScript.getAttribute('data-skip-presence') === 'true';

  const container: Element = thisScript.parentElement || thisScript;

  const rawState: ?string = thisScript.getAttribute('data-state');
  const dataState: Object = rawState ? qs.parse(rawState) : {};

  let lang: ?string = null;
  if (dataState.locale) {
    lang = dataState['locale']; // Fallback to locale in old widgets if lang is not set
  }
  if (dataState.lang) {
    lang = dataState['lang'];
  }

  if (dataState.currentDiscountCode) {
    dataState['currentDiscountCode'] = {
      code: dataState.currentDiscountCode
    };
  }

  if (dataState.accessKeys) {
    dataState['accessKeys'] = dataState.accessKeys.split(',').map(i => i.trim());
  }

  if (!container || container === document.head) {
    return;
  }

  if (!widgetType || !targetType || !targetId) {
    return;
  }

  // register widget to orchestrator
  const initState: WidgetInitState = { ...dataState, targetType, targetId, widgetHeight, filtersEnabled, skipPresence, lang };
  const widget: ?EmbedWidget = orc.register(container, widgetType, initState);

  // mount widget to DOM
  if (widget) {
    widget.mount(thisScript);
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/plugins/registerWidget.js